import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

export class Impressum extends Component {
  static displayName = Impressum.name;

  render() {
    return (
      <div style={{ marginBottom: '60px' }}>
        <Helmet>
          <title>Impressum - ho.li design</title>
          <meta name="description" content="Impressum der ho.li design GmbH" />
          <meta name="keywords" content="Impressum, ho.li design, rechtliche Hinweise" />
          <meta name="language" content="de" />
          <link rel="canonical" href="https://holidesign.de/impressum" />
        </Helmet>
        <h1 style={{ marginBottom: '40px' }}>Impressum</h1>
        <p style={{ marginBottom: '30px' }}>
          ho.li design GmbH <br />
          Otto-Rienecker-Str. 24 <br />
          97789 Oberleichtersbach <br />
          Germany
        </p>
        <p style={{ marginBottom: '30px' }}>
          E-Mail: info@holidesign.de <br />
          Website: www.holidesign.de
        </p>
        <p style={{ marginBottom: '30px' }}>
          Handelsregister Schweinfurt: HRB 9454 <br />
          Geschäftsführer: Laura Albert, Andreas Albert <br />
          Gerichtsstand: Schweinfurt  <br />
          USt-Id: DE369215996
        </p>
        <p><strong>Rechtliche Hinweise</strong></p>
        <p style={{ marginBottom: '30px' }}>
        Der gesamte Inhalt der Website einschließlich aller Texte, Grafiken, Bilder, Fotos, Ton‑, Video- und Animationsdateien sind Eigentum der ho.li design GmbH. Alle Elemente der Website, einschließlich des allgemeinen Designs und des Inhalts, werden durch Urheberrechte geschützt. Die Vervielfältigung, Bearbeitung, Einspeicherung und jede Art der Verwertung des Inhalts, insbesondere der Texte und Bilder ist nicht gestattet bzw. bedürfen der schriftlichen Genehmigung des Erstellers.
        </p>
        <p><strong>Streitschlichtung</strong></p>
        <p style={{ marginBottom: '30px' }}>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:&nbsp;
          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>. <br />
          Unsere E-Mail-Adresse finden Sie oben im Impressum. <br />
          <br />
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
        <p><strong>Haftungshinweis</strong></p>
        <p style={{ marginBottom: '30px' }}>
          Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
        </p>
        <p><strong>Copyright</strong></p>
        <p>
          Alle auf dieser Website eingestellten Texte, Grafiken und Fotos sind urheberrechtlich geschützt und dürfen ohne schriftliche Genehmigung des Urhebers – privat oder kommerziell – weder kopiert, reproduziert und gedruckt, noch in anderer veränderter Art oder unveränderter Art genutzt werden.
        </p>
      </div>
    );
  }
}
